export default __webpack_public_path__ + "888346a052252789ca9319c07811822b.png";